import React, { Component, memo } from "react";
import styles from "./tournamentFilter.module.css";
import PropTypes from "prop-types";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
//components
import TournamentApis from "../../helper/tournament.api";
import { errorHandler, regions, updateLoader } from "../../utils/common.utils";
//images and icons
import "../../styles/PublicTournaments.css";
import "../../styles/Layout.css";
import { AiOutlineSearch } from "react-icons/ai";
import { IoMdArrowDropdown } from "react-icons/io";
import { NavLink } from "react-router-dom";
import TeamApis from "../../helper/teams.api";
import MatchesApis from "../../helper/matches.api";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import MatchInvite from "../popup/MatchInvite";
import AcceptInvite from "../popup/AcceptInvite";
import { FaFilter } from "react-icons/fa";
import Pagination from "react-js-pagination";
import { addParticipantToFirstRound, getTournamentData } from "../../utils/Tournament.utils";
import { profile } from "../../utils/localstorage.utils";
import { getAllGamesDetails } from "../../utils/Games.utils";
import TournamentFilters, { TournamentStatusButtons } from "./tournamentFilters";
import {
  ParticipantType,
  ListingType,
  TournamentVisibility,
  PrizePoolType,
  TournamentStatus,
  GamingPlatforms,
} from "../../utils/enums.utils";
import TournamentCard from "../organization/tournaments/common/TournamentCard";

// Memoized TournamentCard component
const MemoizedTournamentCard = memo(TournamentCard);

// Constants
const FILTER_PARAMS = [
  "gameId",
  "platform",
  "isBettingEnabled",
  "listingType",
  "participantType",
  "region",
  "entryFee",
  "prizePoolType",
  "tournamentStatus",
  "searchTerm",
  "searchValue",
];

const INITIAL_PAGE_SIZE = 30;

export default class Tournament extends Component {
  static propTypes = {
    state: PropTypes.shape({
      joinTournamentId: PropTypes.string,
      stageId: PropTypes.string,
      matchId: PropTypes.string,
      gameId: PropTypes.string,
      groupIndex: PropTypes.string,
      participantType: PropTypes.string,
      isRoundRobin: PropTypes.string,
    }),
    showOrHideNav: PropTypes.func.isRequired,
    clearInvitations: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    logout: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.initializeState();
    this.initializeApis();
  }

  initializeState = () => {
    this.state = {
      tournamentsArray: [],
      searchInput: "",
      showFilters: false,
      acceptTournamentInvite: false,
      teamsArray: [],
      openConfirm: false,
      participantType: this.props?.state?.participantType || null,
      param: null,
      totalResults: 0,
      activePage: 1,
      allGames: [],
      isLoadingPastTournaments: false,
      motivationalMessages: [
        "Ready to make your mark in gaming history?",
        "Your next victory awaits in past tournaments!",
        "Discover legendary matches and epic moments!",
        "Join the ranks of tournament champions!",
        "Every tournament is a chance to become a legend!",
      ],
    };
  };

  initializeApis = () => {
    this.apiPayload = {};
    this.tournamentApis = new TournamentApis();
    this.teamApis = new TeamApis();
    this.matchesApis = new MatchesApis();
    this.offSet = INITIAL_PAGE_SIZE;
    this.pageNo = 0;
  };

  componentDidMount() {
    this.handleTournamentJoinParams();
    this.initializeFiltersFromURL();
    getAllGamesDetails(this.setAllGamesDetails);
    this.props.showOrHideNav(true);

    // Add URL change listener
    window.addEventListener("popstate", this.handleUrlChange);
  }

  componentWillUnmount() {
    // Remove URL change listener
    window.removeEventListener("popstate", this.handleUrlChange);
  }

  handleUrlChange = () => {
    // Reset state and reinitialize filters when URL changes
    this.pageNo = 0;
    this.setState({ activePage: 1 }, () => {
      this.initializeFiltersFromURL();
    });
  };

  handleTournamentJoinParams = () => {
    const { state } = this.props;
    const queryParams = new URLSearchParams(window.location.search);

    if (
      state?.joinTournamentId &&
      state.stageId &&
      (state.matchId || state.groupIndex) &&
      state.gameId &&
      state.participantType
    ) {
      this.setState({
        param: {
          joinTournamentId: state.joinTournamentId,
          stageId: state.stageId,
          matchId: state.matchId,
          gameId: state.gameId,
          groupIndex: state.groupIndex,
          participantType: state.participantType,
          isRoundRobin: state.isRoundRobin,
        },
      });
    }

    if (
      queryParams.get("joinTournamentId") &&
      queryParams.get("stageId") &&
      (queryParams.get("matchId") || queryParams.get("groupIndex")) &&
      queryParams.get("gameId") &&
      queryParams.get("participantType")
    ) {
      const param = {
        joinTournamentId: state?.joinTournamentId,
        stageId: state?.stageId,
        matchId: state?.matchId,
        gameId: state?.gameId,
        groupIndex: state?.groupIndex,
        participantType: state?.participantType,
        isRoundRobin: state?.isRoundRobin,
      };

      this.setState({ param });
      getTournamentData(param, this.setTournamentDetails);
    }
  };

  initializeFiltersFromURL = () => {
    const queryParams = new URLSearchParams(window.location.search);

    // Reset apiPayload to ensure clean state
    this.apiPayload = {
      pageNo: this.pageNo,
      limit: this.offSet,
      visibility: TournamentVisibility.PUBLIC,
    };

    // Get tournament status from URL or default to ongoing/upcoming
    const tournamentStatus =
      queryParams.get("tournamentStatus") ||
      `${TournamentStatus.ONGOING},${TournamentStatus.UPCOMING},${TournamentStatus.COMPLETED}`;

    this.apiPayload.tournamentStatus = tournamentStatus;

    FILTER_PARAMS.forEach(param => {
      const value = queryParams.get(param);
      if (value) {
        if (param === "isBettingEnabled" || param === "entryFee") {
          this.apiPayload[param] = JSON.parse(value);
        } else {
          this.apiPayload[param] = value;
        }
      }
    });

    if (queryParams.get("searchValue")) {
      this.setState({ searchInput: queryParams.get("searchValue") });
    }

    // Always fetch data when filters are initialized
    this.getData(this.apiPayload);
  };

  updateURLWithFilters = values => {
    const queryParams = new URLSearchParams(window.location.search);

    FILTER_PARAMS.forEach(param => queryParams.delete(param));

    Object.entries(values).forEach(([key, value]) => {
      if (value && value !== "") {
        queryParams.set(
          key,
          ["isBettingEnabled", "entryFee"].includes(key) ? JSON.stringify(value) : value
        );
      }
    });

    window.history.pushState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
  };

  getData = async params => {
    try {
      updateLoader(true);
      // Remove any undefined or null values from params
      const queryParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value != null && value !== "")
      );

      if (params.tournamentStatus) {
        const statuses = Array.isArray(params.tournamentStatus)
          ? params.tournamentStatus
          : [params.tournamentStatus];

        if (!statuses.includes("ALL") && !statuses.includes("COMPLETED")) {
          if (statuses.includes("UPCOMING")) {
            queryParams.sortBy = "registrationStartTime";
            queryParams.orderBy = "asc";
          } else if (statuses.includes("ONGOING")) {
            queryParams.sortBy = "tournamentStartTime";
            queryParams.orderBy = "asc";
          }
        }
      }

      const res = await this.tournamentApis.getPublicTournaments(queryParams);
      const { result, totalResults } = res.data;

      this.setState({
        tournamentsArray: result,
        totalResults,
      });
    } catch (err) {
      errorHandler(err, this.props.logout);
    } finally {
      updateLoader(false);
      // Only clear apiPayload if we're not fetching past tournaments
      if (!params.tournamentStatus || params.tournamentStatus !== TournamentStatus.COMPLETED) {
        this.apiPayload = {};
      }
    }
  };

  passDetails = values => {
    this.setState({ showFilters: false });

    const data = this.transformFilterValues(values);
    this.updateURLWithFilters(values);

    this.apiPayload = {
      ...this.apiPayload,
      ...data,
      pageNo: this.pageNo,
      limit: this.offSet,
    };

    this.getData(this.apiPayload);
  };

  transformFilterValues = values => {
    const data = { ...values };

    if (data.listingType) {
      data["entryFeeAndPrizeDetails.listingType"] = data.listingType;
      delete data.listingType;
    }

    if (data.prizePoolType === "NONE_PRIZE_POOL_FILTER") {
      data["entryFeeAndPrizeDetails.prizePoolType"] = "NONE";
      delete data.prizePoolType;
    } else if (data.prizePoolType) {
      data["entryFeeAndPrizeDetails.prizePoolType"] = data.prizePoolType;
      delete data.prizePoolType;
    }

    if (data.entryFee) {
      data["entryFeeAndPrizeDetails.entryFee"] = JSON.parse(data.entryFee);
      delete data.entryFee;
    }

    if (this.state.searchInput?.length) {
      data.searchTerm = "name";
      data.searchValue = this.state.searchInput;
    }

    return data;
  };

  clearFilters = () => {
    window.history.pushState({}, "", window.location.pathname);

    this.pageNo = 0;
    this.apiPayload = {};
    const params = {
      pageNo: 0,
      limit: this.offSet,
      visibility: TournamentVisibility.PUBLIC,
      tournamentStatus: `${TournamentStatus.ONGOING},${TournamentStatus.UPCOMING},${TournamentStatus.COMPLETED}`,
    };

    this.getData(params);
    this.setState({
      showFilters: false,
      searchInput: "",
      activePage: 1,
    });
  };

  searchFilter = e => {
    const { value } = e.target;
    const queryParams = new URLSearchParams(window.location.search);

    this.apiPayload = {
      ...this.apiPayload,
      pageNo: this.pageNo,
      limit: this.offSet,
    };

    if (value?.length >= 3) {
      this.apiPayload.searchTerm = "name";
      this.apiPayload.searchValue = value;
      queryParams.set("searchTerm", "name");
      queryParams.set("searchValue", value);
    } else if (value === "") {
      queryParams.delete("searchTerm");
      queryParams.delete("searchValue");
      delete this.apiPayload.searchTerm;
      delete this.apiPayload.searchValue;
    }

    window.history.pushState({}, "", `${window.location.pathname}?${queryParams.toString()}`);
    this.getData(this.apiPayload);
  };

  tournamentSearch = e => {
    const searchText = e.target.value;
    const letters = /^[a-zA-Z ]*$/;

    if (searchText === "" || searchText.match(letters)) {
      this.setState({ searchInput: searchText });
      this.searchFilter(e);
    } else {
      toast.warning("Only alphabet with spaces allowed");
    }
  };

  handlePageChange = pageNumber => {
    this.apiPayload = {
      ...this.apiPayload,
      pageNo: pageNumber - 1,
      limit: this.offSet,
    };

    this.getData(this.apiPayload);
    this.setState({ activePage: pageNumber });
  };

  renderTournamentFilters = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const initialValues = {
      gameId: queryParams.get("gameId") || "",
      platform: queryParams.get("platform") || "",
      isBettingEnabled: queryParams.get("isBettingEnabled") || "",
      listingType: queryParams.get("listingType") || "",
      participantType: queryParams.get("participantType") || "",
      region: queryParams.get("region") || "",
      entryFee: queryParams.get("entryFee") || "",
      prizePoolType: queryParams.get("prizePoolType") || "",
      tournamentStatus:
        queryParams.get("tournamentStatus") ||
        `${TournamentStatus.ONGOING},${TournamentStatus.UPCOMING}`,
    };

    return (
      <TournamentFilters
        allGames={this.state.allGames}
        onFilterChange={this.passDetails}
        onClearFilters={this.clearFilters}
        initialValues={initialValues}
      />
    );
  };

  renderEmptyState = () => {
    const randomMessage =
      this.state.motivationalMessages[
        Math.floor(Math.random() * this.state.motivationalMessages.length)
      ];

    return (
      <div className="text-center py-5 px-3">
        <h2 className="text-white mb-4 fs-24 fw-600">{randomMessage}</h2>
        <p className="text-white-50 mb-4 fs-16 fw-400">
          Explore our collection of past tournaments and relive the excitement of previous
          competitions. Who knows? You might find your next challenge!
        </p>
        <button
          onClick={this.fetchPastTournaments}
          disabled={this.state.isLoadingPastTournaments}
          className="pink-skyblue-gradient-btn px-4 py-2 rounded-pill text-white border-0"
          style={{
            minWidth: "200px",
            opacity: this.state.isLoadingPastTournaments ? 0.7 : 1,
            transition: "all 0.3s ease",
          }}
        >
          {this.state.isLoadingPastTournaments ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </>
          ) : (
            "Explore Past Tournaments"
          )}
        </button>
      </div>
    );
  };

  renderTournamentList = () => (
    <div className="row g-2">
      {this.state.tournamentsArray?.map((tournament, id) => (
        <div className="col-6 col-md-4 col-lg-2 text-white" key={tournament._id}>
          <NavLink to={`/tournament/${tournament._id}`} style={{ textDecoration: "none" }}>
            <MemoizedTournamentCard tournament={tournament} id={id} />
          </NavLink>
        </div>
      ))}
      {!this.state.tournamentsArray.length && this.renderEmptyState()}
    </div>
  );

  renderTournamentStatusButtons = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const currentStatus =
      queryParams.get("tournamentStatus") ||
      `${TournamentStatus.ONGOING},${TournamentStatus.UPCOMING},${TournamentStatus.COMPLETED}`;

    return (
      <div className={styles.filterButtonsContainer}>
        <div className={styles.scrollableButtons}>
          <div className={styles.buttonsWrapper}>
            <div className={styles.filterButtonWrapper}>
              <TournamentStatusButtons
                currentStatus={currentStatus}
                onStatusChange={this.handleStatusChange}
              />
            </div>
          </div>
        </div>
        <div className={styles.filterActionButton}>
          <button
            onClick={() => this.setState({ showFilters: !this.state.showFilters })}
            className={`btn btn-sm rounded-pill px-3 ${styles.statusButton}`}
          >
            <FaFilter className="me-1" /> Filters
          </button>
        </div>
      </div>
    );
  };

  handleStatusChange = status => {
    const queryParams = new URLSearchParams(window.location.search);
    queryParams.set("tournamentStatus", status);
    window.history.pushState({}, "", `${window.location.pathname}?${queryParams.toString()}`);

    this.initializeFiltersFromURL();
  };

  render() {
    const { showFilters } = this.state;

    return (
      <section
        className="body-section public-tournaments layout1 pb-0"
        style={{ backgroundColor: "#200c45" }}
      >
        <section className="container mt-lg-5 p-3 mb-5">
          {this.renderSearchBar()}
          {this.renderMyTournamentsButton()}
          {this.renderTournamentStatusButtons()}

          {showFilters && (
            <div className="p-2 rounded-3 mb-3" style={{ backgroundColor: "#493d62" }}>
              {this.renderTournamentFilters()}
            </div>
          )}

          {this.renderTournamentList()}
          {this.state.totalResults > this.offSet && (
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={this.offSet}
              totalItemsCount={this.state.totalResults}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange}
              className="mt-5"
            />
          )}
        </section>

        {this.renderModals()}
      </section>
    );
  }

  renderSearchBar = () => (
    <div className="row">
      <div className="col-lg-6 offset-lg-3 col-12">
        <div className="purple-field d-flex align-items-center">
          <input
            type="search"
            placeholder="search"
            onChange={e => this.tournamentSearch(e)}
            value={this.state.searchInput}
            className="w-100 border-0 ps-3 text-white fs-14 height-45 flex-grow-1"
            style={{ backgroundColor: "transparent", outline: "none" }}
          />
          <AiOutlineSearch className="btn-size-20 me-3 text-white flex-shrink-0" />
        </div>
      </div>
    </div>
  );

  renderMyTournamentsButton = () => (
    <div className="row justify-content-between">
      <div className="col-lg-6 offset-lg-3 col-12 mt-3">
        <NavLink to="/tournaments/my-tournaments">
          <button className="pink-skyblue-gradient-btn w-100 fw-bold p-3 m-auto mb-2 text-white border-0">
            My Tournaments
          </button>
        </NavLink>
      </div>
    </div>
  );

  renderFilterToggle = () => (
    <div className="row justify-content-between">
      <div className="col-lg-2 col-6 my-3">
        <div
          className="purple-field d-flex align-items-center w-100 border-0 ps-3 text-white fs-14 height-45 flex-grow-1 justify-content-between"
          onClick={this.toggleFilterStatus}
        >
          <h6 className="my-auto ms-2">Filter</h6>
          <IoMdArrowDropdown className="mx-2" />
        </div>
      </div>
    </div>
  );

  renderModals = () => (
    <>
      <Modal centered show={this.state.acceptTournamentInvite} dialogClassName="ClanInvite-modal">
        {this.state.participantType === ParticipantType.SINGLE ? (
          <Modal.Body>
            <AcceptInvite
              clearInvitations={this.clearInvitations}
              tournamentId={this.props.state.joinTournamentId}
              addParticipantInTournament={this.addParticipantInTournament}
              joinTeamRole={null}
              close={this.clearInvitations}
              type="add"
              info={{}}
              title="Accept Invite"
              role="player"
              matchId={this.props.state.matchId}
              isTournamentInvitation={true}
            />
          </Modal.Body>
        ) : (
          <Modal.Body>
            <MatchInvite
              onClickOpenInvite={this.onClickOpenInvite}
              isPaidTournament={
                this.state.param?.joinTournamentDetails?.entryFeeAndPrizeDetails?.entryFee
              }
              teamsArray={this.state.teamsArray}
              param={this.state.param}
              choice="Join Tournament"
              isRoundRobin={false}
              clearParams={this.clearParams}
              joinTournamentDetails={this.state.param?.joinTournamentDetails}
              history={this.props.history}
            />
          </Modal.Body>
        )}
      </Modal>

      <Modal show={this.state.openConfirm} centered dialogClassName="Confirmation-modal">
        <Modal.Body>
          <div className="p-3">
            <h1 className="fs-20 fw-600 error-msg text-center">Warning</h1>
            <p className="fs-16 fw-500 text-white text-center mt-3">
              There isn't any existing team for this game. Please create one and try again later.
            </p>
            <div className="d-flex justify-content-evenly">
              <NavLink to="/clans">
                <button className="white-flat-btn fw-bold py-2 px-4">Go to clans</button>
              </NavLink>
              <button
                className="white-flat-btn fw-bold py-2 px-4"
                onClick={() => this.setState({ openConfirm: false })}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );

  toggleFilterStatus = () => {
    this.setState({ showFilters: !this.state.showFilters });
  };

  onClickOpenInvite = joinTeamId => {
    this.setState({
      acceptTournamentInvite: !this.state.acceptTournamentInvite,
    });
    if (joinTeamId) {
      this.addParticipantInTournament(this.props.state.matchId, joinTeamId);
    }
  };

  joinTournament = (groupIndex, joinTeamId) => {
    let data = {
      tournamentId: this.props.state.joinTournamentId,
      stageIndex: parseInt(this.props.state.stageId),
      groupIndex: parseInt(groupIndex),
      participantId: joinTeamId,
    };
    updateLoader(true);
    this.tournamentApis
      .joinRoundRobinTournament(data)
      .then(res => {
        toast.success("You are participated in tournament successfully");
        updateLoader(false);
        this.props.history.push(`/tournament/${this.props.state.joinTournamentId}`);
      })
      .catch(reason => {
        updateLoader(false);
        errorHandler(reason);
      });
  };

  clearParams = isRedirect => {
    if (isRedirect) {
      this.props.history.push(`/tournament/${this.state.param.joinTournamentId}`);
    }
    this.setState({
      param: null,
      acceptTournamentInvite: false,
    });
  };

  getDistributePrizeToDetails = () => {
    if (
      this.state.param?.joinTournamentDetails?.entryFeeAndPrizeDetails?.entryFee &&
      this.state.param?.joinTournamentDetails?.participantType === "SINGLE"
    ) {
      return [profile().id];
    }
    return null;
  };

  addParticipantInTournament = (matchId, participantId, tournamentId) => {
    if (
      parseInt(this.state.param?.stageId) === 0 &&
      this.state.param?.isRoundRobin !== "true" &&
      this.state.param?.joinTournamentDetails?.competitionType === "DUEL"
    ) {
      let data = {
        participantId: participantId,
        groupIndex: this.state.param?.groupIndex ? parseInt(this.state.param.groupIndex) : null,
        distributePrizeTo: this.getDistributePrizeToDetails(),
      };
      addParticipantToFirstRound(this.state.param, data, this.clearParams);
    } else {
      if (this.state.param.isRoundRobin === "true") {
        let data = {
          tournamentId: this.state.param.joinTournamentId,
          stageIndex: parseInt(this.state.param.stageId),
          groupIndex: parseInt(this.state.param.groupIndex),
          participantId: participantId,
        };

        updateLoader(true);
        this.matchesApis
          .addParticipantToRoundRobin(data)
          .then(res => {
            toast.success(res.data.result);
            updateLoader(false);
            this.props.history.push(`/tournament/${this.state.param.joinTournamentId}`);
            this.clearParams();
          })
          .catch(reason => {
            updateLoader(false);
            this.clearParams();
            errorHandler(reason);
          });
      } else {
        let data = {
          participantId: participantId,
          distributePrizeTo: this.getDistributePrizeToDetails(),
        };

        updateLoader(true);
        this.matchesApis
          .addParticipants(this.state.param.matchId, data)
          .then(res => {
            toast.success("You are participated in tournament successfully");
            updateLoader(false);
            this.props.history.push(`/tournament/${this.state.param.joinTournamentId}`);
            this.clearParams();
          })
          .catch(reason => {
            updateLoader(false);
            this.clearParams();
            errorHandler(reason);
          });
      }
    }
  };

  setTournamentDetails = data => {
    if (this.state.participantType === "TEAM") {
      this.setState({
        param: data,
      });
      this.getMyTeams(this.props.state.gameId);
    } else {
      this.setState({
        param: data,
        acceptTournamentInvite: true,
      });
    }
  };

  setAllGamesDetails = response => {
    this.setState({ allGames: response });
  };

  getMyTeams = id => {
    updateLoader(true);
    const data = {
      gameId: id,
    };
    this.teamApis
      .getMyTeams(data)
      .then(res => {
        if (res.data.result.length > 0) {
          if (res.data.result.length === 1) {
            this.addParticipantInTournament(this.props.state.matchId, res.data.result[0]._id);
          } else {
            this.setState({
              teamsArray: res.data.result,
              acceptTournamentInvite: true,
            });
          }
        } else {
          this.setState({ openConfirm: true });
        }
        this.props.clearInvitations();
        updateLoader(false);
      })
      .catch(err => {
        this.props.clearInvitations();
        updateLoader(false);
        errorHandler(err);
      });
  };

  clearInvitations = () => {
    this.props.clearInvitations();
    this.setState({
      acceptTournamentInvite: !this.state.acceptTournamentInvite,
    });
  };

  getMatchDetails = (matchId, joinTeamId) => {
    const data = {
      _id: matchId,
    };

    this.matchesApis
      .getMatchDetails(data)
      .then(res => {
        let response = res.data["result"];
        this.updateMatchDetails(
          response[0],
          response[0]["participants"],
          joinTeamId,
          response[0]["maxParticipantsPerMatch"]
        );
        updateLoader(false);
      })
      .catch(err => {
        updateLoader(false);
        errorHandler(err, this.props.logout);
      });
  };

  updateMatchDetails = (matchDetails, participants, joinTeamId, maxParticipantsPerMatch) => {
    if (maxParticipantsPerMatch === undefined || participants.length < maxParticipantsPerMatch) {
      participants.push(joinTeamId);

      let data = {
        participants: participants,
      };

      updateLoader(true);
      this.matchesApis
        .updateMatchDetails(matchDetails._id, data)
        .then(res => {
          toast.success("You are participated in tournament successfully");
          updateLoader(false);
          this.props.history.push(`/tournament/${this.props.state.joinTournamentId}`);
        })
        .catch(reason => {
          updateLoader(false);
          errorHandler(reason);
        });
    } else {
      toast.error("Match slot has been booked already please contact Admin.");
    }
  };

  fetchPastTournaments = () => {
    this.setState({ isLoadingPastTournaments: true });

    // Start with required parameters
    const params = {
      pageNo: 0,
      limit: this.offSet,
      visibility: TournamentVisibility.PUBLIC,
      tournamentStatus: TournamentStatus.COMPLETED,
    };

    // Only add filters if they have values
    if (this.apiPayload.gameId) params.gameId = this.apiPayload.gameId;
    if (this.apiPayload.platform) params.platform = this.apiPayload.platform;
    if (this.apiPayload.region) params.region = this.apiPayload.region;
    if (this.apiPayload.participantType) params.participantType = this.apiPayload.participantType;

    // Clear other filters that might interfere
    this.apiPayload = params;

    this.getData(params).finally(() => {
      this.setState({
        isLoadingPastTournaments: false,
        activePage: 1, // Reset to first page
      });
    });
  };
}
